import { AppRoutes } from './app-routes'
import { hasAuthCallbackParams } from './helpers/login-return-to'

export type BootTarget = 'app' | 'consent' | 'email'

export const MCP_CONSENT_LOGIN_PENDING = 'mcp_consent_login_pending'

export const isMcpConsentTarget = (target: string | undefined): boolean => {
  if (!target?.startsWith('/') || target.startsWith('//')) return false
  return target.split(/[?#]/, 1)[0] === AppRoutes.McpAuthorize()
}

export const bootTarget = (pathname: string, search: string, consentLoginPending: boolean): BootTarget => {
  if (pathname === AppRoutes.McpAuthorize()) return 'consent'
  if (pathname === AppRoutes.EmailUnsubscribe() || pathname === AppRoutes.EmailPreferences()) return 'email'
  return pathname === '/' && consentLoginPending && hasAuthCallbackParams(search) ? 'consent' : 'app'
}
